import moment from 'moment'
import React, { useState, useRef } from 'react'
import { useEffect } from 'react';
import Select from 'react-select';
import { directory, Evaluation, getIndividualGoal, goalLimit, postGoal } from '../service/PerformanceAPI';
import $ from 'jquery'
import '../containers/Appreciation/Appreciation.css'
import { encryptStorage } from '../constant'

export default function EvaluationPopUp(props) {


    const [showEmployee, setShowEmployee] = useState([])
    const [showEvaluation, setShowEvaluation] = useState([])
    const [selectedPeopleList, setSelectedPeopleList] = useState([]);
    const [selectedEvaluationList, setSelectedEvaluationList] = useState([]);
    const [selectedValidation, setselectedValidation] = useState('');
    const [Page, setPage] = useState("")
    const [heading, setHeading] = useState("")

    const [evaluationShow, setEvaluationShow] = useState({});
    const [reachedGoalLmit, setReachGoalLimit] = useState('')
    const [goalLimitPopUp, setGoalLimitPopUp] = useState(false)
    const [goalName, setGoalName] = useState('')
    const [goalId, setGoalId] = useState()
    const [show, setShow] = useState(true)
    const [employeeShow, setEmployeeShow] = useState(false)
    const [evaluationPeriod, setEvaluationPeriod] = useState()
    const [flag, setFlag] = useState(false)
    const [toastColor, settoastColor] = useState()
    const [closeToastInserted, setCloseToastInserted] = useState(false)
    const [closeToastUpdated, setCloseToastUpdated] = useState(false)
    const [ID, setID] = useState()
    const [Image, setImage] = useState('')




    useEffect(() => {
        if (props.Page == 'copyto') {
            bind()

        }

        if (props.Page == 'GoalView') {
            setShow(true)
        }

        if (props.Page === 'button') {
            setID(props.ID)
            setImage(props.Image)
        }

        if (props.Page === 'Success Insert') {
            setID(props.ID)
        }

        if (props.Page !== undefined) setPage(props.Page)
        if (props.Heading !== undefined) setHeading(props.Heading)
        if (props.EvaluationShow) setEvaluationShow(props.EvaluationShow)
        if (props.GoalId !== undefined) setGoalId(props.GoalId)
        if (props.goalName !== undefined && props.goalName !== '') { setGoalName(props.goalName) }
        if (props.closeInsert !== undefined) setCloseToastInserted(props.closeInsert)
        if (props.closeUpdate !== undefined) setCloseToastUpdated(props.closeUpdate)
        if (props.color !== undefined) settoastColor(props.color)




    }, [props.Page, props.goalName, props.Heading, props.GoalId, props])

    useEffect(() => {
        Evaluation({ currentEvaluation: "evaluation", copyTo: "copyto" }).then(res => {
         
            let samplearray = [];
            setEvaluationPeriod(res.data.ResponseData)
            let temparray = res.data.ResponseData
            for (let i = 0; i <= temparray.length - 1; i++) {
                let start = moment(temparray[i].start_date).format("MMM, YYYY")
                let End = moment(temparray[i].end_date).format("MMM, YYYY")
                let objresponse = {
                    value: temparray[i].id,
                    img: "/Images/logo-person-user-person-icon.jpg",
                    label: `${start} - ${End}`,
                    username: `${start} - ${End}`
                }
                samplearray.push(objresponse);
            }
            setShowEvaluation(samplearray);
            res.data.ResponseData.map((result, i) => {
                if (result.current_period === "1") {
                    setSelectedEvaluationList([{
                        value: result.id,
                        img: "/Images/logo-person-user-person-icon.jpg",
                        label: `${moment(result.start_date).format("MMM, YYYY")} - ${moment(result.end_date).format("MMM, YYYY")}`,
                        username: `${moment(result.start_date).format("MMM, YYYY")} - ${moment(result.end_date).format("MMM, YYYY")}`
                    }])
                }
            })
        })
    }, [])

    const handleChangeEvaluation = (e) => {
      
        let selectedValue = [];
        let attend = []
        selectedValue.push(e)
        setSelectedEvaluationList(selectedValue);
    }

    const handleChange = (e) => {
    

        let selectedValue = [];
        let attend = []
        selectedValue.push(e)
        // for (const data of e) {
        //     attend.push(data.value)
        // }
        setSelectedPeopleList(selectedValue);
    }

    const closePopUp = (value) => {
     
        if (value) {
            setGoalLimitPopUp(!goalLimitPopUp)
        }
    }

    const bind = async (value) => {
        let empResult
        if (value === 'team') { empResult = await directory({ domain: "domain" }) }
        else if (encryptStorage.getItem('role') == 'Hr Manager' || encryptStorage.getItem('role') == 'Hr') { empResult = await directory({}) }
        else {
            empResult = await directory({ empId: encryptStorage.getItem('employeeId') })
        }
        // if (value === 'team') { empResult = await directory({ domain: "domain" }) } else { empResult = await directory({ empId: encryptStorage.getItem('employeeId') }) }
        let samplearray = [];
        let temparray = empResult.data.ResponseData.emplist
        for (let i = 0; i <= temparray.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,
                img: "/Images/logo-person-user-person-icon.jpg",
                label: temparray[i].emp_name,
                username: temparray[i].emp_name
            }
            samplearray.push(objresponse);
        }
        setShowEmployee(samplearray);
    }



    const checkCopyTo = async () => {
     
        if (selectedPeopleList.length === 0) {
            setselectedValidation('Assign To is required')
        }
        else {
            let valueCheck = await goalCheck()
            if (valueCheck) {
                let res = await getIndividualGoal({ "goalId": goalId })
                if (res.data.ResponseData.length > 0) {
                 

                    let individualData = {
                        goalId: goalId,
                        goalTitle: res.data.ResponseData[0]?.goal_name,
                        goalDescription: res.data.ResponseData[0]?.description,
                        goalTemplateId: res.data.ResponseData[0]?.goal_template_id,
                        goalType: 'individual',
                        assignedTo: selectedPeopleList,
                        assignedBy: encryptStorage.getItem('employeeId'),
                    };
                  
                    let attend = []
                    individualData.assignedTo.map(data => {
                        attend.push(data.value)
                    })
                    let postData = {
                        goalTitle: individualData.goalTitle,
                        goalDescription: individualData.goalDescription,
                        goalType: individualData.goalType,
                        evaluationPeriodId: selectedEvaluationList[0].value,
                        goalTemplateId: individualData.goalTemplateId,
                        assignedTo: attend,
                        assignedBy: individualData.assignedBy
                    };
                 
                    let postResponse = await postGoal(postData);
                    if (postResponse.data.ResponseData.Message == "Successfully inserted") {
                        // navigate("/performance");
                      
                        props?.hide(false, true)
                    }
                }

            }
            else {
                setselectedValidation("Goal Limit Reached")
                // return false
            }
        }
    }


    const goalCheck = async () => {
       
        if (selectedPeopleList.length > 0) {

            let obj = {
                empId: selectedPeopleList,
                evaluationPeriodId: selectedEvaluationList[0].value
            }

            let limitResult = await goalLimit(obj)

            if (limitResult?.data?.ResponseData?.length > 0 && limitResult?.data?.ResponseData !== undefined) {
                let employeesName = limitResult?.data?.ResponseData?.join(" ,")
                setReachGoalLimit(employeesName)
                setGoalLimitPopUp(true)

                return false
            }
            else setReachGoalLimit('')
        }
        return true
    }

    if (Page == "GoalView") {
        const closePopupFun = (value) => {
           
            props.Click(value)
            setShow(false)
        }

        return (
            <>
                <div className="modal fade" id="goalView100" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="goalView100Label" style={{ display: show ? 'none' : 'block' }} aria-hidden="true" >
                    {/* <div className="modal fade" id="goalView100" tabIndex={-1} aria-labelledby="goalView100Label" style={{ display: show ? 'none' : 'block' }} aria-hidden="true"> */}
                    <div className="modal-dialog goal-popup-per modal-dialog-centered" style={{ "max-width": "666px !important;" }}>
                        <div className="modal-content px-5">
                            <div className="modal-body text-center px-5 py-4">
                                <span><img src="/Images/Honeybee.svg" className="honeybee-img" /></span>
                                <p className="bold-text font-18 text-blue my-5">Are you sure that you have completed
                                    100% of the goal?</p>
                                <div className="text-center d-flex justify-content-center">
                                    <button data-bs-dismiss='modal' onClick={() => { closePopupFun(false) }} type="button" className="btn hive-btn-secondary bold-text font-14 me-3">No,Check Again</button>
                                    <button data-bs-dismiss='modal' onClick={() => { closePopupFun(true) }} className="btn hive-btn-primary bold-text font-14" type="submit">Yes Completed</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    if (Page == "GoalLimit") {
        return (
            <div className="modal show" id="goalLimit" tabIndex={-1} aria-labelledby style={{ display: 'block' }} aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content px-5">
                        <div className="modal-body text-center px-5 py-4">
                            <span><img src="/Images/Honeybee.svg" className="honeybee-img" /></span>
                            <p className="bold-text font-18 text-blue my-5">{heading}</p>
                            <div className="text-center d-flex justify-content-center">
                                <button onClick={() => { props.Click(true) }} className="btn hive-btn-primary bold-text font-14" type="submit">Oops</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    if (Page == "copyto") {
        return (
            <>
                <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)" }} id={props?.ID ? props?.ID : 'copyto'} tabIndex={-1} aria-labelledby="copytoLabel">
                    <div className="modal-dialog Offboard-popup-width modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="align-items-center justify-content-inbetween">
                                    <div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <div className="d-flex">

                                                    <p className=" font-15 tt-bold mb-0 d-flex mt-2 me-3">Selected Goal</p>
                                                </div>
                                            </div>
                                            <div>
                                                <button onClick={() => props?.hide(false)} id='copyToClose' type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                            </div>
                                        </div>
                                        <div className='d-flex'>
                                            <a className="text-deco-none mt-3">
                                                <img src="/Images/orange-arrow.svg" alt="orange-arrow" className="me-2" />
                                            </a>
                                            <p className="mt-4 mb-4 bold-text font-16">{goalName}</p>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <label className="form-label hive-form-label w-100">Copy to</label>
                                                <Select
                                                    className="dropdown"
                                                    name='period'
                                                    maxMenuHeight={150}
                                                    placeholder="Select Evaluation Period"
                                                    value={selectedEvaluationList}
                                                    options={showEvaluation} // set list of the data
                                                    onChange={(e) => { handleChangeEvaluation(e) }} // assign onChange function
                                                />
                                            </div>
                                            <div className='col-md-6'>
                                                <label className="form-label hive-form-label w-100">Assign to</label>
                                                <div className='row'>
                                                    <Select
                                                        className="dropdown"
                                                        name='assigned_to_id'
                                                        maxMenuHeight={150}
                                                        placeholder="Select"
                                                        value={selectedPeopleList}
                                                        options={showEmployee} // set list of the data
                                                        onChange={(e) => { setselectedValidation(''); handleChange(e) }} // assign onChange function
                                                        isClearable
                                                    />
                                                    <label className='text-danger'> {selectedValidation}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center d-flex justify-content-end mt-2">
                                    <button onClick={() => props?.hide(false)} data-bs-dismiss="modal" type="button" className="btn hive-btn-secondary bold-text font-14 me-3">Cancel</button>
                                    <button onClick={() => { checkCopyTo() }} className="btn hive-btn-primary bold-text font-14" type="submit">Copy</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    }
    if (Page == "Delete") {
        return (
            <div className="modal show" id="exampleModal" tabIndex={-1} aria-labelledby style={{ display: 'block' }} aria-modal="true" role="dialog">
                <div className="modal-dialog goal-popup modal-dialog-centered">
                    <div className="modal-content px-5">
                        <div className="modal-body text-center px-5 py-4">
                            <span><img src="/Images/Honeybee.svg" className="honeybee-img" /></span>
                            <p className="bold-text font-18 text-blue my-5">Are you sure do you want to delete</p>
                            <div className="text-center d-flex justify-content-center">
                                <button onClick={() => { props.Delete(false) }} type="button" className="btn hive-btn-secondary bold-text font-14 me-3">No</button>
                                <button onClick={() => { props.Delete(true) }} className="btn hive-btn-primary bold-text font-14" type="submit">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    if (Page == "Success Delete") {
        return (
            <div id='deleted' className="position-fixed col-md-12 position-toast d-flex justify-content-center end-0 p-3" style={{ zIndex: 11 }}>
                <div id="liveToast" className="toast side-toast show" role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="col-md-12 p-2 float-start">
                        <div className>
                            <div className="toast-header border-toast">
                                <img className="tick px-2 float-start" src="/Images/green-tick.svg" alt="toast" />
                                <div className="float-start px-3 pe-3">
                                    <div className="bold-text font-18 toast-font-black">{props.Heading}</div>
                                    <div className="body-toast semibold-text font-12 toast-font-grey ">{props.Paragraph}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
    if (Page == "Success Update") {

        setTimeout(() => {
            setCloseToastUpdated(true)
        }, 2500);

        return (
            <div id='updated' style={{ zIndex: 11 }} className={closeToastUpdated ? `d-none` : `position-fixed col-md-12 position-toast d-flex justify-content-center end-0 p-3`}>
                <div id="liveToast" className="toast side-toast show" role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="col-md-12 p-2 float-start">
                        <div className>
                            <div className="toast-header border-toast">
                                <img className="tick px-2 float-start" src="/Images/green-tick.svg" alt="toast" />
                                <div className="float-start px-3 pe-3">
                                    <div className="bold-text font-18 toast-font-black">{props.Heading}</div>
                                    <div className="body-toast semibold-text font-12 toast-font-grey ">{props.Paragraph}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
    if (Page == "Success Insert") {

        setTimeout(() => {
            setCloseToastInserted(true)
            if(props.Paragraph=="Email Delivery Successful" || props.Paragraph=="Email Delivery Unsuccessful"){
                setCloseToastInserted(true);
            }
        }, 2500);

        return (
            <div id={ID ? ID : 'inserted'} className={closeToastInserted ? `d-none` : `position-fixed col-md-12 position-toast d-flex justify-content-center end-0 p-3`} style={{ zIndex: 11 }}>
                <div id="liveToast" className={toastColor ? `toast ${toastColor}-toast show` : `toast side-toast show`} role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="col-md-12 p-2 float-start">
                        <div className>
                            <div className="toast-header border-toast">
                                <img className="tick px-2 float-start" src={toastColor ? `/Images/${toastColor}-tick.svg` : "/Images/green-tick.svg"} alt="toast" />
                                <div className="float-start px-3 pe-3">
                                    <div className="bold-text font-18 toast-font-black">{props.Heading}</div>
                                    <div className="body-toast semibold-text font-12 toast-font-grey ">{props.Paragraph}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
    if (Page == 'button') {

        const clickedButton = () => {

            if (ID) {
                sessionStorage.setItem(ID, false);
                setEmployeeShow(true)
            }
            else {
                sessionStorage.setItem('EvaluationStarted', false);
                setEmployeeShow(true)
            }

        }
        return (
            <>
                <div className='modal-backdrop' style={employeeShow ? { display: 'none' } : { opacity: "0.5" }}></div>
                <div className="modal fade show" id={ID ? ID : "Evaluationstarted"} tabIndex={-1} aria-labelledby={ID ? ID + `Label` : `EvaluationstartedLabel`} style={{ display: employeeShow ? 'none' : 'block' }} aria-modal="true" role="dialog">
                    <div className="modal-dialog goal-popup-per modal-dialog-centered" style={{ "max-width": "666px !important;" }}>
                        <div className="modal-content px-5">
                            <div className="modal-body text-center py-4">
                                <span><img src={Image ? `/Images/${Image}` : `/Images/Honeybee.svg`} className="honeybee-img" /></span>
                                <p className="bold-text font-18 text-blue my-5">{heading}</p>
                                <div className="text-center d-flex justify-content-center">
                                    <button onClick={() => { clickedButton() }} className="btn hive-btn-primary bold-text font-14" type="submit">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

}
